import { toastError } from "../../../commons/utils";
import { IContext } from "../../../contexts/AuthProvider/types";
import { SlotProps } from "../../Gallery";

export async function uploadMovimentoArquivo(auth: IContext, movid: any, file: any) {
    const body = {
        movarqid: file.uuid,
        movid,
        movarqtipo: file.filename || 'Geral',
        movarqurl: file.url
    };

    try {
        const result: any = (await auth.post('/v1/movimentoarquivoone', body));
        return { ...result.data, uuid: result.data.movarqid }
    } catch (error: any) {
        toastError(error);
    }
}

export async function deleteMovimentoArquivo(auth: IContext, movid: any, file: any) {
    const body = {
        ...file,
        _delete: 1
    };

    try {
        await auth.deleteRequest('/v1/movimentoarquivo', body);
    } catch (error: any) {
        toastError(error);
    }
}

export async function getFilesMovimento(auth: IContext, tipmovcontador: number, movid: number) {
    try {
        const response_slots: any = await auth.get('/v1/tipomovimentoarquivo?tipmovcontador=' + tipmovcontador + '&tipmovarqativo=1');
        const response_files: any = await auth.get('/v1/movimentoarquivo?movid=' + movid + '&movarqativo=1');

        if (response_slots?.data) {
            const slots: SlotProps[] = response_slots.data.map((item: any) => {
                const fileMatch = response_files.data.find((file: any) => file.movarqtipo === item.tipmovarqtipo && file._delete !== 1);

                return {
                    ...fileMatch,
                    url: fileMatch ? fileMatch.movarqurl : undefined,
                    uuid: fileMatch ? fileMatch.movarqid : undefined,
                    name: item.tipmovarqtipo,
                    allowsPdf: item.tipmovarqpdf,
                    allowsImage: item.tipmovarqimagem,
                };
            });

            return slots;
        } else {
            return [];
        }
    } catch (error: any) {
        toastError(`Erro ao carregar arquivos: ${error.message || error}`);
        return [];
    }
}
